"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var client_1 = require("@apollo/client");
var style_1 = require("./style");
var Message_1 = __importDefault(require("../Feedback/Message"));
function ErrorHandler(_a) {
    var values = _a.values, errors = _a.errors, submitCount = _a.submitCount, skipNotRelatedErrorCheck = _a.skipNotRelatedErrorCheck;
    if (skipNotRelatedErrorCheck || !submitCount) {
        return null;
    }
    var existValuesKeys = Object.keys(values);
    var errorsKeys = Object.keys(errors);
    var notRelatedErrorsKeys = errorsKeys.filter(function (errorKey) { return !existValuesKeys.includes(errorKey); });
    var notRelatedErrors = notRelatedErrorsKeys.map(function (errorKey) { return errors[errorKey]; });
    var formatMessage = function (msg) {
        if (typeof msg === "string") {
            return msg;
        }
        console.warn("Field error should be string");
        return JSON.stringify(msg);
    };
    return notRelatedErrors.length ? (react_1.default.createElement(style_1.StyledAlert, { type: "error", message: notRelatedErrors.map(function (msg, i) { return (react_1.default.createElement("div", { key: notRelatedErrorsKeys[i] }, formatMessage(msg))); }) })) : null;
}
function Form(_a) {
    var _this = this;
    var mutation = _a.mutation, mutationVariablesFormatter = _a.mutationVariablesFormatter, children = _a.children, formikProps = _a.formikProps, onSuccess = _a.onSuccess, _b = _a.skipMutation, skipMutation = _b === void 0 ? false : _b, _c = _a.layout, layout = _c === void 0 ? "vertical" : _c, _d = _a.skipNotRelatedErrorCheck, skipNotRelatedErrorCheck = _d === void 0 ? false : _d;
    var mutationAction = client_1.useMutation(mutation)[0];
    var onSubmit = function (formikValues, formikHelpers) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("Form.onSubmit", formikValues);
                    if (skipMutation) {
                        formikHelpers.setSubmitting(false);
                        formikHelpers.resetForm();
                        Message_1.default({
                            content: "Success",
                            type: "success",
                        });
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(formikValues, {});
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, mutationAction({
                            variables: mutationVariablesFormatter === null || mutationVariablesFormatter === void 0 ? void 0 : mutationVariablesFormatter(formikValues),
                        })
                            .then(function (response) {
                            console.log("Form.onSubmit - response", response);
                            formikHelpers.resetForm();
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(formikValues, response);
                            Message_1.default({
                                content: "Success",
                                type: "success",
                            });
                        })
                            .catch(function (e) {
                            console.log("Form.onSubmit - error", e);
                            console.log("Form.onSubmit - e?.graphQLErrors", e === null || e === void 0 ? void 0 : e.graphQLErrors);
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            e === null || e === void 0 ? void 0 : e.graphQLErrors.forEach(function (graphQLError) {
                                var _a;
                                if ((_a = graphQLError === null || graphQLError === void 0 ? void 0 : graphQLError.context) === null || _a === void 0 ? void 0 : _a.field) {
                                    formikHelpers.setFieldError(graphQLError.context.field, graphQLError.message);
                                }
                            });
                            Message_1.default({
                                content: (e === null || e === void 0 ? void 0 : e.message) || "Error",
                                type: "error",
                            });
                        })
                            .finally(function () {
                            formikHelpers.setSubmitting(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "ant-form ant-form-" + layout },
        react_1.default.createElement(formik_1.Formik, __assign({}, formikProps, { onSubmit: onSubmit, enableReinitialize: true }), function (formikState) { return (react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement(ErrorHandler, { errors: formikState.errors, values: formikState.values, submitCount: formikState.submitCount, skipNotRelatedErrorCheck: skipNotRelatedErrorCheck }),
            typeof children === "function" ? children(formikState) : children)); })));
}
exports.default = Form;
